
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {
		id_status: 'aberta'
	},
	lista: [],
	listaMotorista: [],
	listaCavalo: [],
	listaCarreta: [],
	listaLog: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PENDENCIA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PENDENCIA_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'PENDENCIA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

		case 'PENDENCIA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
		
		case 'PENDENCIA_LOG_LISTADO':
            return {
				...state,
				listaLog: action.payload.data
			};

        case 'PENDENCIA_MOTORISTA_SELECT_LISTADO':
            return {
				...state,
				listaMotorista: action.payload.data
			};

		case 'PENDENCIA_PLACA_SELECT_LISTADO':
            return {
				...state,
				listaCavalo: action.payload.data.filter(item => item.tracao).map(item => ({ id: item.placa, valor: item.placa })),
				listaCarreta: action.payload.data.filter(item => !item.tracao).map(item => ({ id: item.placa, valor: item.placa }))
			};

        default:
            return state;
	}
}
